const FPItemTypes = {
  CARD: 'card',
};

export default FPItemTypes;